module.exports = __webpack_public_path__ + "static/media/shareexpinfo-logo.34ff3383cb3f7007015335c936abacc5.svg";